import { render, staticRenderFns } from "./cloudOrderDetails.vue?vue&type=template&id=53c288c5&"
import script from "./cloudOrderDetails.vue?vue&type=script&lang=js&"
export * from "./cloudOrderDetails.vue?vue&type=script&lang=js&"
import style0 from "./cloudOrderDetails.vue?vue&type=style&index=0&id=53c288c5&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports